import { PropsWithChildren } from 'react';

import { ChevronRightIcon } from '@radix-ui/react-icons';
import { AnimatePresence, motion } from 'motion/react';

import {
  Button,
  Collapsible,
  CollapsibleTrigger,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
} from '@app-evolution-cms/element-ui';

interface MenuGroupProps {
  id: string;
  isEditMode?: boolean;
  isOpen?: boolean;
  label: string;
  onDeleteGroup?: VoidFunction;
  onOpenChange?: (open: boolean) => void;
}

export function MenuGroup({
  children,
  id,
  isEditMode = false,
  isOpen = true,
  label,
  onDeleteGroup,
  onOpenChange,
}: PropsWithChildren<MenuGroupProps>) {
  return (
    <Collapsible asChild className="group/collapsible2" open={isOpen} onOpenChange={onOpenChange}>
      <SidebarGroup>
        <SidebarGroupLabel asChild className="px-0">
          <div className="group/item mb-1 flex items-center justify-between gap-2">
            <CollapsibleTrigger asChild>
              <Button className="mx-[2px] w-full justify-start gap-2" variant="ghost" size="sm">
                <ChevronRightIcon className="size-4 shrink-0 transition-transform duration-200 group-data-[state=open]/collapsible2:rotate-90" />
                <span>{label}</span>
              </Button>
            </CollapsibleTrigger>
            {isEditMode && (
              <Button
                className="w-[4.1rem] flex-none p-0 text-destructive"
                size="xs"
                variant="link"
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                  e.preventDefault();
                  onDeleteGroup?.();
                }}
              >
                Eliminar
              </Button>
            )}
          </div>
        </SidebarGroupLabel>
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              style={{ overflow: 'hidden' }}
            >
              <SidebarMenu id={id} className="p-[2px]">
                {children}
              </SidebarMenu>
            </motion.div>
          )}
        </AnimatePresence>
      </SidebarGroup>
    </Collapsible>
  );
}
